<template>
  <div class="page-listini-detail">
    <listini-detail />
  </div>
</template>

<script>
import ListiniDetail from '@/components/ask/details/ListiniDetail.vue'

export default {
  name: 'ViewListiniDetail',
  components: {
    ListiniDetail,
  },

  data() {
    return {
      pageName: 'ListiniDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
